function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import keyPairShape from 'shapes/keyPairShape';
import App, { AlertsBus } from 'modules/App';
import Account from 'modules/Account';
import { SetCloudDrive } from 'modules/CloudDrive';
import * as constants from '../../../../constants';
var _React_PureComponent;
class AttachCloudDrive extends (_React_PureComponent = React.PureComponent) {
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsxs("header", {
                    className: "pageHeader",
                    children: [
                        /*#__PURE__*/ _jsx("h1", {
                            className: "text--h1",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, Account.messages.headers.setCloudDrive))
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "pageHeader__intro",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, Account.messages.intros.setCloudDrive))
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(AlertsBus, {
                    className: "mb-5"
                }),
                /*#__PURE__*/ _jsx(SetCloudDrive, {
                    type: "pwd",
                    keyPair: this.props.keyPair,
                    formValues: this.props.formValues,
                    onSetFormValue: this.props.onSetFormValue,
                    onSetFormValues: this.props.onSetFormValues
                })
            ]
        });
    }
}
_define_property(AttachCloudDrive, "propTypes", {
    // Implicit props
    keyPair: keyPairShape,
    formValues: PropTypes.object,
    // Implicit actions
    onSetFormValue: PropTypes.func,
    onSetFormValues: PropTypes.func
});
const mapStateToProps = (state)=>({
        keyPair: Account.selectors.keyPair(state),
        formValues: App.selectors.formSelector(constants.PATIENT_PROFILE_FORM)(state)
    });
const mapDispatchToProps = (dispatch)=>{
    const formName = constants.PATIENT_PROFILE_FORM;
    return {
        onSetFormValue: (input)=>dispatch(App.actions.setFormValue(formName, input)),
        onSetFormValues: (values)=>dispatch(App.actions.setFormValues(formName, values))
    };
};
const ConnectedAttachCloudDrive = connect(mapStateToProps, mapDispatchToProps)(AttachCloudDrive);
export default ConnectedAttachCloudDrive;
